import {Component, Input, OnDestroy} from '@angular/core';
import {NgForm} from "@angular/forms";
import {ParameterService} from '../../../shared/services/midOffice/parameter.service';
import {ActivatedRoute} from "@angular/router";
import {NotificationService} from "../../../shared/services/notification.service";
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';
import {UtilsService} from '../../../shared/services/utils.service';

@Component({
  selector: 'app-parameter-form',
  templateUrl: './parameter-form.component.html',
  styleUrls: ['./parameter-form.component.scss']
})
export class ParameterFormComponent implements  OnDestroy {
  @Input() parameterCode: string = '' ;
  @Input() parameter: any = [] ;
  @Input() message: string | undefined;

  addEditParameterSubscription: Subscription
  constructor(private parameterService: ParameterService,private utilsService: UtilsService,private route: ActivatedRoute,private notifyService : NotificationService,public activeModal: NgbActiveModal) { }

  ngOnDestroy() {
    if (this.addEditParameterSubscription) {
      this.addEditParameterSubscription.unsubscribe();
    }
  }


  onSubmit(AddEditForm: NgForm) {
    if(AddEditForm.valid) {
      this.utilsService.loadingShow();
      this.addEditParameterSubscription = this.parameterService.addEditParameter(this.parameterCode ,this.parameter).subscribe(
        parameter => {
          this.parameter = parameter;
          if (this.message == 'add') {
            this.notifyService.showSuccess('Création effectuée avec succès',"")
          } else {
            this.notifyService.showSuccess('Mise à jour effectuée avec succès',"")
          }
          this.activeModal.close()
        },
        error => {
          this.notifyService.showError(error.error.message ?? (error.message ?? ''),"")
        }
      )
    }
  }
}
